// a vue composable that provides screen size related utilities following tailwindcss screen logics

import { ref, computed, onMounted, onUnmounted } from 'vue';

export function useScreen() {
    const width = ref(window.innerWidth);

    const isMobile = computed(() => width.value < 640);
    const isTablet = computed(() => width.value >= 640 && width.value < 1024);
    const isDesktop = computed(() => width.value >= 1024);

    const sm = 640;
    const md = 768;
    const lg = 1024;
    const xl = 1280;
    const xxl = 1536;

    const isSm = computed(() => width.value < sm);
    const isMd = computed(() => width.value >= sm && width.value < md);
    const isLg = computed(() => width.value >= md && width.value < lg);
    const isXl = computed(() => width.value >= lg && width.value < xl);
    const isXxl = computed(() => width.value >= xl);

    let isCordova = computed(() => {
        return typeof window.cordova !== "undefined";
    });

    let isAppMobile = computed(() => {
        return isMobile.value && isCordova.value;
    });

    const updateWidth = () => {
        width.value = window.innerWidth;
    };

    onMounted(() => {
        window.addEventListener('resize', updateWidth);
    });

    onUnmounted(() => {
        window.removeEventListener('resize', updateWidth);
    });

    return {
        width,
        sm,
        md,
        lg,
        xl,
        xxl,
        isSm,
        isMd,
        isLg,
        isXl,
        isXxl,
        isMobile,
        isTablet,
        isDesktop,
        isAppMobile
    };
}
